angular.module("ainapp")
    .controller("productForcasitingController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Product Forcasiting";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    ProductIds: [],
                }
                $scope.load = false;

            }
            $scope.Init();

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.ProductIds = $scope.filter.ProductIds;

                        MainService.ProductForecastingReport(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })


                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            AverageSales: {
                                type: "number",
                                editable: false,
                            },
                            Green: {
                                type: "string",
                                editable: false,
                            },
                            Orange: {
                                type: "string",
                                editable: false,
                            },
                            Red: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Name",
                        title: "Product",
                        },
                    
                    {
                        field: "AverageSales",
                        title: "Average Sales",
                     },
                     {
                        field: "Green",
                        title: "60 + Day Inventory",
                     },
                    {
                        field: "Orange",
                        title: "30 - 60 Days",
                     },
                     {
                        field: "Red",
                        title: "< 30 Days",
                     },
                  

                    ],
            };


            $scope.Filter = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            
              $scope.Refresh = function () {
                  $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }





        }])
